import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter } from "lucide-react";
import { CONTACT, SERVICES } from "@/data/site";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="mt-0 bg-rossi-cream text-rossi-bg">
      <div className="container-rossi pt-16 pb-6 border-b border-rossi-bg/15">
        <p className="font-serif font-semibold text-[13vw] lg:text-[150px] leading-none tracking-[0.18em] text-rossi-bg">ROSSI<span className="serif-italic text-rossi-terracotta text-[6vw] lg:text-[64px] tracking-normal ml-4">Ceramiche</span></p>
      </div>
      <div className="container-rossi py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 [&_.eyebrow]:text-rossi-terracotta [&_a]:text-rossi-bg/75 [&_a:hover]:text-rossi-bg">
        <div>
          <p className="text-sm text-rossi-bg/60 leading-relaxed">
            Italian materials, British craftsmanship. Tiling, bathroom &amp; wet room installation across Stockport and the North West.
          </p>
          <div className="flex gap-3 mt-5">
            <a href="#" aria-label="Facebook" className="p-2 border border-rossi-bg/20 transition-colors"><Facebook size={16} /></a>
            <a href="#" aria-label="Instagram" className="p-2 border border-rossi-bg/20 transition-colors"><Instagram size={16} /></a>
            <a href="#" aria-label="X" className="p-2 border border-rossi-bg/20 transition-colors"><Twitter size={16} /></a>
          </div>
        </div>

        <div>
          <h4 className="eyebrow mb-4">Services</h4>
          <ul className="space-y-2 text-sm">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}`} className="text-rossi-cream/75 hover:text-rossi-gold transition-colors">{s.title}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="eyebrow mb-4">Explore</h4>
          <ul className="space-y-2 text-sm">
            {[["The Studio", "/studio"], ["Gallery", "/gallery"], ["Projects", "/projects"], ["Material Calculator", "/calculator"], ["Book Consultation", "/booking"], ["Get a Quote", "/quote"], ["FAQ", "/faq"], ["Reviews", "/reviews"]].map(([l, to]) => (
              <li key={to}><Link to={to} className="text-rossi-cream/75 hover:text-rossi-gold transition-colors">{l}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="eyebrow mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-rossi-bg/80">
            <li className="text-rossi-bg/55">Owner: <span className="text-rossi-bg">{CONTACT.owner}</span></li>
            <li><a href={CONTACT.phoneHref} className="flex items-center gap-2 hover:text-rossi-gold transition-colors"><Phone size={15} className="text-rossi-gold" /> {CONTACT.phone}</a></li>
            <li><a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2 hover:text-rossi-gold transition-colors"><Mail size={15} className="text-rossi-gold" /> {CONTACT.email}</a></li>
            <li className="flex items-start gap-2"><MapPin size={15} className="text-rossi-gold mt-0.5" /> <span>{CONTACT.location}<br /><span className="text-rossi-stone text-xs">{CONTACT.address}</span></span></li>
            <li className="text-xs text-rossi-gold/90 font-mono uppercase tracking-widest pt-1">{CONTACT.membership}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-rossi-bg/10 [&_a]:text-rossi-bg/60 [&_a:hover]:text-rossi-bg">
        <div className="container-rossi py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-rossi-bg/50">
          <p>&copy; {new Date().getFullYear()} Rossi Ceramics. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <Link to="/legal" className="hover:text-rossi-gold transition-colors">Privacy</Link>
            <Link to="/legal" className="hover:text-rossi-gold transition-colors">Cookies</Link>
            <Link to="/legal" className="hover:text-rossi-gold transition-colors">Terms</Link>
            <Link to="/staff" data-testid="footer-staff-portal" className="hover:text-rossi-gold transition-colors">Staff Portal</Link>
            <Link to="/admin/login" data-testid="footer-admin-portal" className="hover:text-rossi-gold transition-colors">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
